import { z } from 'zod';

export const AUDIT_ACTIONS = [
  'auth.signin',
  'auth.signout',
  'auth.signin_failed',
  'auth.password_changed',
  'user.created',
  'user.updated',
  'module_permission.updated',
  'contact.created',
  'contact.updated',
  'integration.gmail_smtp.saved',
  'integration.gmail_smtp.tested',
  'integration.sendgrid.saved',
  'integration.sendgrid.tested',
  'integration.whatsapp.saved',
  'integration.whatsapp.tested',
  'integration.uwm.saved',
  'integration.uwm.tested',
  'integration.uwm_pricing.saved',
  'integration.uwm_pricing.tested',
  'integration.fcm_coda.saved',
  'integration.fcm_coda.tested',
  'lender_sheets.refreshed',
  'pricing.company_lenders.updated',
  'lender_sheets.uploaded',
  'integration.pennymac_power.saved',
  'integration.pennymac_power.tested',
  'integration.sunwest_sunsoft.saved',
  'integration.sunwest_sunsoft.tested',
  'integration.amwest_pipeline.saved',
  'integration.amwest_pipeline.tested',
  'integration.springeq_emma.saved',
  'integration.springeq_emma.tested',
  'integration.tls_email.saved',
  'integration.tls_email.tested',
  'integration.tls_portal.saved',
  'integration.tls_portal.tested',
  'integration.newrez_portal.saved',
  'integration.newrez_portal.tested',
  'integration.cardinal_sheet.saved',
  'integration.cardinal_email.tested',
  'lender_pricing.comp_plan_updated',

  'sync.queued',
  'sync.started',
  'sync.completed',
  'sync.failed',
  'lender_pipeline.synced',
  'realtor_contacts.imported',
  'realtor_contacts.deleted',
  'realtor_email.opted_out',
  'realtor_email.resubscribed',
  'loan.assignment.changed',
  'loan.title_company.updated',
  'workflow.evaluated',
  'workflow.paused',
  'workflow.resumed',
  'workflow.manual_run',
  // Phase 1 workflow lifecycle actions:
  'workflow.created',
  'workflow.updated',
  'workflow.archived',
  'workflow.deleted',
  'workflow.published',
  'workflow.unpublished',
  'workflow.copied',
  'workflow.version_created',
  'workflow.test_run_queued',
  'workflow.dry_run',
  'workflow.instance_cancelled',
  'workflow.graph_exported',
  'notification.sent',
  'lender_pricing.schedule_created',
  'lender_pricing.schedule_updated',
  'lender_pricing.schedule_deleted',
  'mana_pricing.schedule_created',
  'mana_pricing.schedule_updated',
  'mana_pricing.schedule_deleted',
  'mana_pricing.schedule_moved',
  'notification.failed',
  'notification.skipped',
  // Maintenance kill-switch flips for outbound email + WhatsApp.
  'org.communication_toggles.changed',
] as const;
export type AuditAction = (typeof AUDIT_ACTIONS)[number];
export const AuditActionSchema = z.enum(AUDIT_ACTIONS);

export const AuditLogSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  actorUserId: z.string().nullable().optional(),
  action: AuditActionSchema,
  entityType: z.string().nullable().optional(),
  entityId: z.string().nullable().optional(),
  beforeJson: z.string().nullable().optional(),
  afterJson: z.string().nullable().optional(),
  ipAddress: z.string().nullable().optional(),
  createdAt: z.string().datetime(),
});
export type AuditLog = z.infer<typeof AuditLogSchema>;
